module.exports = __webpack_public_path__ + "img/img18.f200e254.svg";